import { render, staticRenderFns } from "./sendWorkflow.vue?vue&type=template&id=1819fcd8&scoped=true"
import script from "./sendWorkflow.vue?vue&type=script&lang=js"
export * from "./sendWorkflow.vue?vue&type=script&lang=js"
import style0 from "./sendWorkflow.vue?vue&type=style&index=0&id=1819fcd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1819fcd8",
  null
  
)

export default component.exports